import { render, staticRenderFns } from "./LabelVisibilityFields.vue?vue&type=template&id=ca5979cc&"
import script from "./LabelVisibilityFields.vue?vue&type=script&lang=js&"
export * from "./LabelVisibilityFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports